// removed by extract-text-webpack-plugin
module.exports = {"download":"download__1RlVR","downloadInfo":"downloadInfo__3QO-9","downloadImage":"downloadImage__2HiNW","downloadDesc":"downloadDesc__R4Nn_","downloadTitle":"downloadTitle__BSgYI","downloadSubtitle":"downloadSubtitle__2vRdZ"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Conversion/DownLoad/index.css
// module id = 1373
// module chunks = 0